export default __webpack_public_path__ + "static/media/enib.18cf7d1d.png";